import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HistorialPagosDetalladosComponent } from './components/historial-pagos-detallados/historial-pagos-detallados.component';

const routes: Routes = [
  {
    path: "historial-pagos-detallado",
    component: HistorialPagosDetalladosComponent,
    data: {
      title: 'Historial de pagos detallado'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportesRoutingModule { }